exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrapper-chart[data-v-33d868aa] { width: 65%; margin: 20px auto;\n}\n", ""]);

// exports
